/* @flow */
/*jshint esversion: 6 */
import { Col, Form, InputNumber, message, Popover } from "antd";
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import TableLineIcons from "../../components/TableLineIcons";
import LangContext from "../../contextProvider/LangContext";
import { Tooltip, Button, Icon } from "antd";
import GenericModal from "../../components/GenericModal";
import DateTimePicker from "../../components/DateTimePicker";
import GenericSelector from "../../components/GenericSelector";
import TableIDs from "../../data/TableIDs";
import { Job, User, OutputType, ProcessType } from '../../JmReact';
import GenericSelectorPosStorages from "../../components/GenericSelectorPosStorages";
import moment from "moment";
import ReportShowButton from "../../components/ReportShowButton";
import { Row } from "antd/es/grid";


class Transactions extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            filters: {
                _date_from: moment().add(-7, "days").format("YYYY-MM-DD"),
                _date_to: moment().format("YYYY-MM-DD"),
                _pos_list: '',
                _sum_from: null,
                _sum_to: null,
                _sort_by: 'col_6',
                _isAsc: '0',
            },
            modalFilter: false,

            filterActive: false,
            valueSearch: '',

        };

        this.id = "TRANSACTIONS_TABLE";

        this.api = {
            get: "get_transactions_table",
        }

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };

        if (props.data[TableIDs.genericSelectorPos] === undefined) props.data[TableIDs.genericSelectorPos] = { ...props.data.genericSelector }

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.sendAPI("list_pos", "", (ob) => {

            let dataset = ob.data ? ob.data.split("\r").map(x => {
                let y = x.split("\f");
                return { code: y[0], name: y[1] }
            }) : [];

            this.setState({ filters: { ...this.state.filters, _pos_list: dataset.map(x => x.code).join(",") } }, () => {
                this.props.dataActions.setJson(TableIDs.genericSelectorPos, { dataset });
                this.filterOk()
            })
        })
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(this.props.loadPaymentsOnly ? 21708 : 16909);
    }

    // renderReport = (text, record) => {
    //     let generateReport = (reportName) => {
    //         this.props.ActionQueue.addToQueue({
    //             action: this.props.dataActions.generateReport,
    //             args: [
    //                 this.props.user.companyCode,
    //                 this.props.user.token,
    //                 {
    //                     _id: record.key,
    //                     _docNum: record.tDocumentNumber,
    //                     _docType: encodeURIComponent(record.tDocumentTypeID + " - " + record.tDocumentTypeName),
    //                     _docPos: encodeURIComponent(record.tPOSID + " - " + record.tPOSName),
    //                     // _docTimestamp: record.tTimestamp,
    //                     reportName: "reports/" + reportName,
    //                     REPORT_LOCALE: this.getText(101),
    //                 }]
    //         });
    //     }

    //     let subButton = (text, type, reportName) => {
    //         let onClick = () => { generateReport(reportName) }
    //         return (
    //             <Tooltip title={this.getText(text)}>
    //                 <Icon style={{ fontSize: 32 }} className={"clickable margin-4"} type={type} onClick={onClick} />
    //             </Tooltip>)
    //     }

    //     let content = (<div>
    //         {subButton(16919, "file-pdf", "TransactionFields.pdf")}
    //         {subButton(16920, "file-excel", "TransactionFields.xls")}
    //         {subButton(16921, "file-word", "TransactionFields.docs")}
    //     </div>);

    //     return (<Popover content={content} title={this.getText(16918)} trigger="click">
    //         {/* <Button key={"report-print"} className={"btn"} style={{ marginTop: "5px", marginLeft: "5px" }}> */}
    //         <Icon style={{ fontSize: 16 }} type={"printer"} theme="outlined" />
    //         {/* </Button> */}
    //     </Popover>)
    // }



    renderReport = (text, record) => {
        return [
            <ReportShowButton {...this.props} iconButton validSubmit tooltip={this.getText(21247)} type={"file-pdf"} params={{
                DocumentNumber: record.tDocumentNumber,
                DocumentTypeID: record.tDocumentTypeID,
                DocumentPOSID: record.tPOSID,
                userID: this.props.user.userId,
                userName: encodeURIComponent(this.props.user.displayName),
                CompanyCode: this.props.user.companyCode,
                isOriginal: false,
                CentralFatherItem: 0,
                PrintFormat: null,
                docIsWithSigns: 0,
                reportName: "reports/DocumentCopy.pdf",
                REPORT_LOCALE: this.getText(101)
            }} />,
            <ReportShowButton {...this.props} iconButton validSubmit tooltip={this.getText(21248)} type={"printer"} params={{
                _id: this.props.loadPaymentsOnly ? 0 : record.tID,
                _docNum: record.tDocumentNumber,
                _docType: encodeURIComponent(record.tDocumentTypeID + " - " + record.tDocumentTypeName),
                _docPos: encodeURIComponent(record.tPOSID + " - " + record.tPOSName),
                byFixedSettings: 0,
                _docTypeId: record.tDocumentTypeID,
                _docPosId: record.tPOSID,
                _uId: this.props.loadPaymentsOnly ? record.tID : '',
                reportName: "reports/TransactionFields.pdf",
                REPORT_LOCALE: this.getText(101)
            }} />,
            <ReportShowButton {...this.props} iconButton validSubmit tooltip={this.getText(21249)} type={"eye"} params={{
                _id: this.props.loadPaymentsOnly ? 0 : record.tID,
                _docNum: record.tDocumentNumber,
                _docType: encodeURIComponent(record.tDocumentTypeID + " - " + record.tDocumentTypeName),
                _docPos: encodeURIComponent(record.tPOSID + " - " + record.tPOSName),
                byFixedSettings: 1,
                _docTypeId: record.tDocumentTypeID,
                _docPosId: record.tPOSID,
                _uId: this.props.loadPaymentsOnly ? record.tID : '',
                reportName: "reports/TransactionFields.pdf",
                REPORT_LOCALE: this.getText(101)
            }} />,
        ]
    }

    filterOk = () => {
        const { _date_from, _date_to, _pos_list, _sum_from, _sum_to } = this.state.filters;

        this.setState({ modalFilter: false }, () => {
            let fullPosList = this.props.data[TableIDs.genericSelectorPos].dataset.map(x => x.code).join(",")

            this.props.dataActions.genericDataSetFilter(
                this.id, this.props.user.companyCode, this.props.user.token, {
                _date_from, _date_to, _sum_from, _sum_to, _pos_list: _pos_list ? _pos_list : fullPosList, loadPaymentsOnly: this.props.loadPaymentsOnly ? 1 : 0
            }, this.api.get);
        })

        this.setState({ filterActive: true })
    }

    clearFilter = () => {
        this.setState({
            filters: {
                ...this.state.filters,
                _date_from: null,
                _date_to: null,
                _sum_from: null,
                _sum_to: null,
                _pos_list: '',
            },
            filterActive: false,
            valueSearch: '',
        }, () => {
            let fullPosList = this.props.data[TableIDs.genericSelectorPos].dataset.map(x => x.code).join(",")
            this.props.dataActions.genericDataSetFilter(
                this.id, this.props.user.companyCode, this.props.user.token, {
                _date_from: null,
                _date_to: null,
                _sum_from: null,
                _sum_to: null,
                _pos_list: fullPosList,
                _words: '',
                loadPaymentsOnly: this.props.loadPaymentsOnly ? 1 : 0
            }, this.api.get);
        });
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    reportAll = (reportName) => {
        const { _words, _sort_by, _isAsc, _date_from, _date_to, _sum_from, _sum_to, _pos_list } = this.props.data[this.id].filters
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.generateReport,
            args: [
                this.props.user.companyCode,
                this.props.user.token,
                {
                    _words: encodeURIComponent(_words),
                    _sort_by, _isAsc, _date_from, _date_to, _sum_from, _sum_to, _pos_list,
                    loadPaymentsOnly: this.props.loadPaymentsOnly ? 1 : 0,
                    reportName,
                    REPORT_LOCALE: this.getText(101),
                }]
        });
    }

    render() {
        let gt = this.getText;
        let sorter = true;
        const render = t => (<p style={{ textAlign: "right", lineHeight: 1, marginTop: 5 }}>{t}</p>)
        const renderDatetime = t => (<p style={{ textAlign: "right", direction: "ltr", lineHeight: 1, marginTop: 5 }}>{moment(t).format("DD/MM/YYYY HH:mm")}</p>)
        const renderSum = t => (<p style={{ textAlign: "right", direction: "ltr", lineHeight: 1, marginTop: 5 }}>₪ {t.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>)

        const divStyle = {
            align: "center",
            dir: "rtl", // dir: "ltr"
            padding: "2% 2% 2% 2%",
        };

        let datePickerFilter = (field, label) => {

            return (<Form.Item label={gt(label)}>
                <DateTimePicker
                    format={"DD/MM/YYYY"}
                    value={this.state.filters[field]}
                    onChange={e => { this.setState({ filters: { ...this.state.filters, [field]: e } }) }}
                    minDate={field == '_date_to' ? this.state.filters._date_from : null}
                    maxDate={field == '_date_from' ? this.state.filters._date_to : null}
                />
            </Form.Item>)
        }

        const { _words, _sort_by, _isAsc, _date_from, _date_to, _sum_from, _sum_to, _pos_list } = this.props.data[this.id].filters

        let columns = this.props.loadPaymentsOnly ? [
            { title: gt(16911), key: "tDocumentNumber", dataIndex: "tDocumentNumber", width: "9%", sorter, render },
            { title: gt(16912), key: "tDocumentTypeID", dataIndex: "tDocumentTypeID", width: "17%", sorter, render: (t, r) => render(t + " - " + r.tDocumentTypeName) },
            { title: gt(16913), key: "tPOSID", dataIndex: "tPOSID", width: "9%", sorter, render },
            { title: gt(16914), key: "tPOSName", dataIndex: "tPOSName", width: "17%", sorter, render },
            { title: gt(16915), key: "tTimestamp", dataIndex: "tTimestamp", width: "17%", sorter, render: renderDatetime },
            { title: gt(17048), key: "tSum", dataIndex: "tSum", width: "11%", sorter, render: renderSum },
            { title: gt(17049), key: "tCardNum", dataIndex: "tCardNum", width: "11%", sorter, render },
            { title: gt(16917), width: "9%", render: this.renderReport },
        ] : [
            { title: gt(16916), key: "tID", dataIndex: "tID", width: "8%", sorter, render },
            { title: gt(16911), key: "tDocumentNumber", dataIndex: "tDocumentNumber", width: "8%", sorter, render },
            { title: gt(16912), key: "tDocumentTypeID", dataIndex: "tDocumentTypeID", width: "16%", sorter, render: (t, r) => render(t + " - " + r.tDocumentTypeName) },
            { title: gt(16913), key: "tPOSID", dataIndex: "tPOSID", width: "8%", sorter, render },
            { title: gt(16914), key: "tPOSName", dataIndex: "tPOSName", width: "16%", sorter, render },
            { title: gt(16915), key: "tTimestamp", dataIndex: "tTimestamp", width: "16%", sorter, render: renderDatetime },
            { title: gt(17048), key: "tSum", dataIndex: "tSum", width: "10%", sorter, render: renderSum },
            { title: gt(17049), key: "tCardNum", dataIndex: "tCardNum", width: "10%", sorter, render },
            { title: gt(16917), width: "8%", render: this.renderReport },
        ]

        const printPopoverContent = this.props.loadPaymentsOnly ?
            (<div>
                <Button icon={"file-pdf"} style={{ marginBottom: 5, width: 200 }} onClick={() => { this.reportAll("reports/Transactions.pdf") }}>
                    {this.getText(21713)}
                </Button>
                <br />
                <Button icon={"file-excel"} style={{ marginBottom: 5, width: 200 }} onClick={() => { this.reportAll("reports/TransactionsExcel.xls") }} >
                    {this.getText(21714)}
                </Button>
                <br />

                <Button icon={"file-excel"} style={{ marginBottom: 5, width: 200 }} onClick={() => {
                    if (this.props.data[this.id].count > 1000) {
                        message.error(this.getText(21717))
                    } else {
                        this.reportAll("reports/TransactionsExcelExpanded.xls")
                    }
                }} >
                    {this.getText(21715)}
                </Button>
                <br />

                <ReportShowButton {...this.props}
                    textBtn={<><Icon type={"eye"} /> {this.getText(21716)}</>}
                    validSubmit params={{
                        _words: encodeURIComponent(_words),
                        _sort_by, _isAsc, _date_from, _date_to, _sum_from, _sum_to, _pos_list,
                        loadPaymentsOnly: 1,
                        reportName: "reports/Transactions.pdf",
                        REPORT_LOCALE: this.getText(101),
                    }} />
            </div>)
            : (<div>
                <Tooltip title={this.getText(12721)}>
                    <Icon style={{ fontSize: 32 }} className={"clickable margin-4"} type={"file-pdf"} onClick={() => { this.reportAll("reports/Transactions.pdf") }} />
                </Tooltip>
                <Tooltip title={this.getText(12722)}>
                    <Icon style={{ fontSize: 32 }} className={"clickable margin-4"} type={"file-excel"} onClick={() => { this.reportAll("reports/TransactionsExcel.xls") }} />
                </Tooltip>
                <ReportShowButton {...this.props} iconButton validSubmit type={"eye"} params={{
                    _words: encodeURIComponent(_words),
                    _sort_by, _isAsc, _date_from, _date_to, _sum_from, _sum_to, _pos_list,
                    loadPaymentsOnly: 0,
                    reportName: "reports/Transactions.pdf",
                    REPORT_LOCALE: this.getText(101),
                }} />
            </div>)


        return (<div style={divStyle}>
            <GenericTable
                {...this.props}
                id={this.id}
                getApi={this.api.get}
                title={gt(this.props.loadPaymentsOnly ? 21708 : 16910)}
                searchBox
                valueSearch={this.state.valueSearch}
                onChangeSearch={e => { this.setState({ valueSearch: e.target.value }) }}
                setFilterActive={e => { this.setState({ filterActive: e }) }}
                keyPerIndex
                rowHeight={40}
                filters={{ ...this.state.filters, loadPaymentsOnly: this.props.loadPaymentsOnly ? 1 : 0 }}
                columns={columns}
                actionButtons={[{
                    buttonType: 'filter',
                    buttonFunction: () => { this.setState({ modalFilter: true }) }
                }, {
                    buttonDisabled: !this.state.filterActive,
                    buttonType: 'clear',
                    buttonFunction: this.clearFilter,
                }]}
                genericActionButtons={[
                    <Tooltip title={this.getText(12720)}>
                        <Popover
                            title={this.getText(12723)}
                            trigger="click"
                            content={printPopoverContent} >
                            <Button key={"report-print"} className={"btn"} style={{ marginTop: "5px", marginLeft: "5px" }}>
                                <Icon style={{ fontSize: 16 }} type={"printer"} theme="outlined" />
                            </Button>
                        </Popover>
                    </Tooltip>
                ]}
            />
            <GenericModal
                visible={this.state.modalFilter}
                onCancel={() => { this.setState({ modalFilter: false }) }}
                title={gt(16925)}
                width={500}
                footer={[
                    <Button key="Cancel" onClick={() => { this.setState({ modalFilter: false }) }}>{gt(16926)}</Button>,
                    <Button key="Clear" onClick={this.clearFilter}>{gt(16927)}</Button>,
                    <Button key="Filter" type={"primary"} onClick={this.filterOk}>{gt(16928)}</Button>,
                ]}
            >
                {datePickerFilter('_date_from', 16929)}
                {datePickerFilter('_date_to', 16930)}
                <Form.Item label={gt(17585)}>
                    <GenericSelectorPosStorages
                        {...this.props}
                        // id={TableIDs.genericSelectorPos}
                        multi
                        value={this.state.filters._pos_list ? this.state.filters._pos_list.split(",") : []}
                        onChange={(e, t) => { this.setState({ filters: { ...this.state.filters, _pos_list: e ? e.join(",") : '' } }) }}
                    />
                </Form.Item>

                <Row>
                    <Col span={12}>
                        <Form.Item label={gt(21518)}>
                            <InputNumber
                                value={this.state.filters._sum_from}
                                onChange={e => { this.setState({ filters: { ...this.state.filters, _sum_from: e } }) }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label={gt(21519)}>
                            <InputNumber
                                value={this.state.filters._sum_to}
                                onChange={e => { this.setState({ filters: { ...this.state.filters, _sum_to: e } }) }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

            </GenericModal>
        </div >)
    }

}

export default Transactions;